import React from 'react'

// image
import bgImage from "../../assets/images/bgImage1.jpg";
import Header from 'components/VerticalLayout/Header';
import { Card, CardTitle, Col, Container, Row } from 'reactstrap';
import ResponsiveTables from 'pages/Tables/ResponsiveTables';

const UserList = () => {
    document.title = "Title Apprasier | User List"
  return (
    <div className='account-pages'>
        <Header/>
        <div className='accountbg'
            style={{
            background: `url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundAttachment:"fixed",
            paddingTop:"80px",
            minHeight:"100vh",
            overflow:"hidden",
            paddingLeft:"8px"
            }}
        >
            <Container fluid>
                <Row>
                    <Col>
                        <Card style={{backdropFilter:"blur(10px)",opacity:"1"}}>
                            <ResponsiveTables/>
                        </Card>
                    </Col>
                </Row>
                
            </Container>
        </div>
    </div>
  )
}

export default UserList